@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackAllieSimple {
  display: flex;
  flex-direction: column;
  color: var(--black);
  padding: 50px 0;

  .cases {
    display: flex;
    gap: 60px;

    .case {
      display: flex;
      width: 33.33%;
      gap: 25px;
      flex-direction: column;
      position: relative;

      &.google {
        width: 42%;

        .name {
          font-size: 27px;
          margin-top: 76px;
        }

        .description {
          font-size: 17px;
        }
      }

      .icon {
        height: 50px;
        width: 50px;
        flex: 0 0 50px;

        &.chart {
          @include icons.ico("black-line-chart");
        }

        &.speedometer {
          @include icons.ico("black-speedometer");
        }

        &.refresh {
          @include icons.ico("black-refresh");
        }

        &.ai {
          @include icons.ico("black-ai-stars");
        }
      }

      .name {
        gap: 15px;
        font-size: 20px;

        @include texts.font("semi-bold");

        .goog {
          width: 101px;
          height: 34px;
          top: 9px;
          margin-top: -10px;
          display: inline-flex;
          position: relative;

          @include icons.ico("colored-google-text");
        }
      }

      .description {
        font-size: 15px;
        color: var(--grey-text);
      }
    }
  }

  @media screen and (max-width: 930px) {
    padding: 0;

    .cases {
      flex-wrap: wrap;

      .case {
        width: 100% !important;
      }
    }
  }
}